/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespSellerItemTileCarousel_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItem_user">;
    readonly " $refType": "PdpRespSellerItemTileCarousel_user";
};
export type PdpRespSellerItemTileCarousel_user$data = PdpRespSellerItemTileCarousel_user;
export type PdpRespSellerItemTileCarousel_user$key = {
    readonly " $data"?: PdpRespSellerItemTileCarousel_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSellerItemTileCarousel_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSellerItemTileCarousel_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItem_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '9e3e40a7b446dcb94fffb63d729acd30';
export default node;
